import { LogOut } from 'lucide-react';
import { signOut } from 'firebase/auth';
import { auth } from '../../firebase';
import { Button } from '../ui';

export default function SignOutButton({ size = 'sm' }: { size?: 'sm' | 'md' }) {
  return (
    <Button
      variant="ghost"
      size={size}
      iconLeft={<LogOut size={14} strokeWidth={1.75} />}
      onClick={() => {
        // Best-effort sign-out. Auth observer keeps the user logged in if
        // this fails, so a retry just works.
        signOut(auth).catch((err) => console.error('signOut failed', err));
      }}
    >
      Sign out
    </Button>
  );
}
